import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getDistricts(params) {
  const searchParams = new URLSearchParams();

  if (params?.stateId) {
    searchParams.set('state_id', String(params.stateId));
  }

  const query = searchParams.toString();
  const endpoint = query ? `/api/districts?${query}` : '/api/districts';

  return apiRequest(endpoint, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
